/**
 * 异常车辆记录
 */
import request from "@/utils/request";

const getAllErrCodeRequestPath = "/api/v2/car/abnormal/code/list";
const getAllErrCode = ()=>{
  return request.get(getAllErrCodeRequestPath);
}


export {
  getAllErrCode
}